'use client';

import { useEffect } from 'react';

export function NonCriticalStyles(): null {
  useEffect(() => {
    const loadNonCriticalStyles = async () => {
      try {
        // Create link element
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/styles/non-critical.css';
        link.media = 'print';
        
        // Add load event listener before appending
        link.addEventListener('load', () => {
          requestAnimationFrame(() => {
            link.media = 'all';
          });
        });
        
        // Handle errors
        link.addEventListener('error', (error) => {
          console.warn('Failed to load non-critical styles:', error);
        });
        
        // Append to head
        document.head.appendChild(link);
      } catch (error) {
        console.warn('Error loading non-critical styles:', error);
      }
    };

    loadNonCriticalStyles();
  }, []);

  return null;
} 